import React, {createRef} from "react";
import {connect} from "react-redux";
import moment from "moment";
import {
  Button,
  DatePicker,
  Icon,
  Input,
  Modal,
  Pagination,
  Table,
} from "../../../components";
import AddIcon from "../../../assets/icons/add.png";
import ModalViewDebit from "./modal-view-debit";
import ModalFindOrder from "./modal-find-order";
import {Constants, Globals, axios} from "../../../utils";
import currency from "../../../services/modules/currency";

// Reemplazar helper functions en Return.js:

const getBillNumber = (item) => {
  return (
    item?.bill_number_formatted ||
    item?.order?.bill_number_format ||
    item?.order?.bill_number ||
    "-"
  );
};

const getBillControlNumber = (item) => {
  return (
    item?.bill_control_number_format ||
    item?.order?.control_number ||
    item?.order?.control_number_format ||
    "-"
  );
};

const getDebitControlNumber = (item) => {
  return (
    item?.debit_control_number_format ||
    item?.control_number_format ||
    item?.control_number ||
    "-"
  );
};

const INITIAL_FILTER = {
  correlative_number: "",
  search: "",
  since: null,
  until: null,
};

class Return extends React.Component {
  state = {
    showCreate: false,
    selectedItem: null,
    selectedClient: null,
    form: {...INITIAL_FILTER},
    data: [],
    page: 1,
    last_page: 1,
  };

  debounce = createRef();

  componentDidMount() {
    this.load();
  }

  load = async (page = 1) => {
    Globals.setLoading();
    const {form} = this.state;
    const since =
      form.since && moment(form.since, "DD-MM-YYYY").format("YYYY-MM-DD");
    const until =
      form.until && moment(form.until, "DD-MM-YYYY").format("YYYY-MM-DD");

    const filter = {
      user_id: this.props.user.id,
      ...form,
      until,
      since,
      page,
    };

    try {
      const res = await axios.post(
        "admin/orders/fiscal-bill/debitnote/get",
        filter,
      );
      console.log("res.data.debit_notes.data", res.data.debit_notes.data);
      this.setState({
        data: res.data.debit_notes.data,
        last_page: res.data.debit_notes.last_page,
        page,
      });
    } catch (error) {
      Globals.showError(
        error?.response?.data?.error || "Ocurrió un error inesperado",
      );
    }

    Globals.quitLoading();
  };

  change = async (value, target) => {
    await this.setState((s) => ({form: {...s.form, [target]: value}}));

    if (["search", "correlative_number"].includes(target)) {
      if (this.debounce.current) clearTimeout(this.debounce.current);
      this.debounce.current = setTimeout(async () => this.load(), 1000);
    } else {
      this.load();
    }
  };

  onSelectClient = async (item) => {
    this.setState({selectedClient: item});
  };

  onSelectItem = async (item) => {
    this.setState({selectedItem: item});
  };

  canResetFilter = () => {
    return JSON.stringify(this.state.form) !== JSON.stringify(INITIAL_FILTER);
  };

  resetFilter = async () => {
    await this.setState({form: {...INITIAL_FILTER}});
    this.load();
  };

  download = async (item) => {
    try {
      const form = {
        id: item.id,
        user_id: this.props.user.id,
        download: true,
        currency: Constants.CURRENCIES.BOLIVARES,
      };

      const res = await axios.post(
        "admin/orders/fiscal-bill/debitnote/get",
        form,
      );
      if (!res.data?.url) throw new Error();

      window.open(res.data.url);
    } catch (error) {
      Globals.showError(
        "Ocurrió un error al generar el PDF. Intente nuevamente.",
      );
    }
  };

  render() {
    const {
      data,
      form,
      last_page,
      page,
      selectedClient,
      selectedItem,
      showCreate,
    } = this.state;

    return (
      <div id="notas-de-debito">
        <Modal
          className="modal-return-create"
          title="Nueva nota de débito"
          visible={showCreate}
          size="xl"
          onClose={(reload) => {
            this.setState({showCreate: false});
            if (reload) this.load();
          }}
        >
          <ModalFindOrder
            debit
            onClose={() => {
              this.setState({showCreate: false});
              this.load();
            }}
          />
        </Modal>

        <Modal
          className="modal-return-details"
          title="Detalles de la nota de débito"
          visible={!!selectedItem}
          size="xl"
          onClose={() => this.onSelectItem(null)}
        >
          <ModalViewDebit
            debitedItem={selectedItem}
            onClose={() => this.onSelectItem(null)}
          />
        </Modal>

        <Modal
          title="Datos del cliente"
          visible={!!selectedClient}
          size="md"
          onClose={() => this.onSelectClient(null)}
        >
          <div>Teléfono: {selectedClient?.phone || "-"}</div>
          <div>Correo: {selectedClient?.email || "-"}</div>
          <div>Dirección: {selectedClient?.address || "-"}</div>

          <div style={{display: "flex", justifyContent: "center"}}>
            <Button
              className="mt-3 btn-filter"
              onClick={() => this.onSelectClient(null)}
            >
              Cerrar
            </Button>
          </div>
        </Modal>

        <div className="row">
          <div className="col-2">
            <Input
              color=" "
              label="N° Nota de débito"
              className="filter"
              onChange={(e) =>
                this.change(e.target.value, "correlative_number")
              }
              value={form.correlative_number}
            />
          </div>
          <div className="col-2">
            <Input
              color=" "
              label="Cliente"
              className="filter"
              onChange={(e) => this.change(e.target.value, "search")}
              value={form.search}
            />
          </div>
          <div className="col-2">
            <DatePicker
              color="white"
              label="Desde"
              className="filter"
              value={form.since}
              onChange={(v) => this.change(v, "since")}
            />
          </div>
          <div className="col-2">
            <DatePicker
              color="white"
              label="Hasta"
              className="filter"
              value={form.until}
              onChange={(v) => this.change(v, "until")}
            />
          </div>
          <div className="col-md ">
            <Button
              className="btn-align-bottom btn-filter"
              color=" "
              onClick={async () => {
                await this.setState({page: 1});
                this.load();
              }}
            >
              <span>Filtrar</span>
            </Button>
            {this.canResetFilter() && (
              <Button
                color="transparent"
                className="btn-align-bottom btn-filter ml-2"
                onClick={this.resetFilter}
              >
                <span>Limpiar</span>
              </Button>
            )}
          </div>
        </div>

        <Table
          title="Registro de Notas de Débito"
          header={[
            "N° de\nnota de débito",
            "N° de control\n/ nota de débito",
            "N° de\nfactura",
            "N° de control\nde factura",
            "Fecha de\nnota de débito",
            "Vendedor",
            "Monto\ntotal Bs",
            "IGTF (3%)\n(Bs.)",
            "Cliente",
            "Datos\ncliente",
            "Acciones",
          ]}
          emptyMessage="No hay notas de débito registradas"
          data={!!data.length ? data : null}
          right={
            <Button
              title="Nueva Nota de Débito"
              small="true"
              onClick={() => this.setState({showCreate: true})}
            >
              <img src={AddIcon} alt="Nueva Nota de Débito" />
            </Button>
          }
        >
          {data.map((item, index) => {
            const igtfBs =
              item.igtf_bs > 0
                ? item.igtf_bs
                : item.igtf
                  ? item.igtf * item.conversion
                  : 0;

            return (
              <tr key={index}>
                <td>{item.number_format || item.correlative_number}</td>
                <td>{getDebitControlNumber(item)}</td>
                <td>{getBillNumber(item)}</td>
                <td>{getBillControlNumber(item)}</td>
                <td>{moment(item.created_at).format("DD/MM/YYYY")}</td>
                <td>{item.order?.seller?.name || "-"}</td>
                <td align="right">
                  Bs. {Globals.formatMiles(item.total * item.conversion)}
                </td>
                <td align="right">
                  {igtfBs > 0 ? Globals.formatMiles(igtfBs) : "-"}
                </td>
                <td>{item.order?.client?.name || "-"}</td>
                <td>
                  <span
                    className="show-client"
                    onClick={() => this.onSelectClient(item.order?.client)}
                  >
                    Ver
                  </span>
                </td>
                <td>
                  <Button
                    title="Imprimir"
                    small="true"
                    onClick={() => this.download(item)}
                  >
                    <Icon name="print" />
                  </Button>
                  <Button
                    title="Ver"
                    small="true"
                    onClick={() => this.onSelectItem(item)}
                  >
                    <Icon name="eye" />
                  </Button>
                </td>
              </tr>
            );
          })}
        </Table>

        <Pagination
          pages={last_page}
          active={page}
          onChange={(page) => this.load(page)}
        />
      </div>
    );
  }
}

export default connect((state) => ({
  user: state.user,
}))(Return);
